import styled from "styled-components";

const Container = styled("div")`
    width: 100vw;
    height: auto;
    background-color: #ffffff;

    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    position: relative;
`

const Title = styled("h1")`
    margin: 0;
    white-space: nowrap;
    font-family: 'Bungee', cursive;
`

const Navbar = () => 
{
    return (
        <Container>
            <Title>
                NFSL Fantasy Football 2022-2023 Season
            </Title>
        </Container>
    )
}

export default Navbar;